<template>
  <div class="add-feedback-container" style="">
    <el-card class="add-feedback-card">
      <el-form :model="form" label-width="160px"  :class="showpopLongtitle === '查看' ? 'on-click' : ''">
        <div class="custom-table-container">
            <!-- 表格主体 -->
            <div class="custom-table">
              <div class="table-title">学生月度综合反馈</div>
              <!-- 第一行：学生姓名、年级、学科 -->
              <div class="table-row">
                <div class="cell label-cell-light">学生姓名</div>
                <div class="cell" style="width: 30%;">
                  <div >{{ form.studentName }}</div>
                </div>
                <div class="cell label-cell-light">年 级</div>
                <div class="cell" style="width: 30%;">
                  <!-- <el-input v-model="form.grade" placeholder="请选择" size="small"></el-input> -->
                  <div >{{ form.grade }}</div>
                </div>
                <div class="cell label-cell-light">学 科</div>
                <div class="cell" style="width: 30%;">
                  <!-- <el-select v-model="form.subject" placeholder="请选择" size="small" style="width: 100%;">
                    <el-option
                      v-for="item in subjects"
                      :key="item.categoryId"
                      :label="item.categoryName"
                      :value="item.categoryId">
                    </el-option>
                  </el-select> -->
                  <div >{{ form.subject }}</div>
                </div>
              </div>

              <!-- 作业完成情况 -->
              <div class="table-row">
                <div class="cell label-cell">作业完成情况</div>
                <div class="cell" colspan="5">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="form.homework"
                    placeholder="请输入作业完成情况"
                    size="small"
                  ></el-input>
                </div>
              </div>

              <!-- 上课听讲情况 -->
              <div class="table-row">
                <div class="cell label-cell">上课听讲情况</div>
                <div class="cell" colspan="5">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="form.classBehavior"
                    placeholder="请输入上课听讲情况"
                    size="small"
                  ></el-input>
                </div>
              </div>

              <!-- 本月教学计划完成情况总结 -->
              <div class="table-row">
                <div class="cell label-cell">
                  <div>
                    <div>本月教学计划</div>
                    <div>完成情况总结</div>
                  </div>
                </div>
                <div class="cell" colspan="5">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="form.summary"
                    placeholder="请输入总结内容"
                    size="small"
                  ></el-input>
                </div>
              </div>

              <!-- 下月教学计划及学习建议（三列） -->
              <div class="table-row">
                <div class="cell label-cell" rowspan="1">下月教学计划及学习建议</div>
                <div style="width: 79%;">
                  <div class="table-row">
                    <div class="cell sub-label">教学内容：</div>
                    <div class="cell" colspan="4">
                      <el-input  type="textarea" v-model="form.planContent" placeholder="请输入教学内容"  size="small" ></el-input>
                    </div>
                  </div>
                  <div class="table-row">
                    <div class="cell sub-label">计划解读：</div>
                    <div class="cell" colspan="4">
                      <el-input  type="textarea" v-model="form.planContent1" placeholder="请输入计划解读"  size="small" ></el-input>
                    </div>
                  </div>
                  <div class="table-row">
                    <div class="cell sub-label">学习建议：</div>
                    <div class="cell" colspan="4">
                      <el-input  type="textarea" v-model="form.planContent2" placeholder="请输入学习建议"  size="small" ></el-input>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 下月教学目标 -->
              <div class="table-row">
                <div class="cell label-cell">下月教学目标</div>
                <div style="width: 79%;">
                  <div class="table-row">
                      <div class="cell sub-label">知识层面：</div>
                      <div class="cell" colspan="4">
                        <el-input  type="textarea" v-model="form.knowledgeGoal" placeholder="请输入知识层面目标"  size="small" ></el-input>
                      </div>
                    </div>
                    <div class="table-row">
                      <div class="cell sub-label">应试层面：</div>
                      <div class="cell" colspan="4">
                        <el-input  type="textarea" v-model="form.examGoal" placeholder="请输入应试层面目标"  size="small" ></el-input>
                      </div>
                    </div>
                </div>
              </div>

              <!-- 近期考试情况 -->
              <div class="table-row">
                <div class="cell label-cell">近期考试情况</div>
                <div class="cell" colspan="5">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="form.examSituation"
                    placeholder="请输入近期考试情况"
                    size="small"
                  ></el-input>
                </div>
              </div>

              <!-- 校园表现及精神面貌 -->
              <div class="table-row">
                <div class="cell label-cell">校园表现及精神面貌</div>
                <div class="cell" colspan="5">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="form.campusBehavior"
                    placeholder="请输入校园表现"
                    size="small"
                  ></el-input>
                </div>
              </div>

              <!-- 学习进步情况 -->
              <div class="table-row">
                <div class="cell label-cell">学习进步情况</div>
                <div class="cell" colspan="5">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="form.progress"
                    placeholder="请输入学习进步情况"
                    size="small"
                  ></el-input>
                </div>
              </div>

              <!-- 审批人 & 提交时间 -->
              <div class="table-row">
                <div class="cell label-cell-light">审批人</div>
                <div class="cell" style="width: 40%;">
                  <!-- <el-select v-model="form.approver" placeholder="请选择" size="small" style="width: 100%;">
                     <el-option v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                  </el-select> -->
                  <div>{{ form.approver }}</div>
                </div>
                <div class="cell label-cell-light">提交时间</div>
                <div class="cell" style="width: 40%;">
                  <!-- <el-date-picker
                    v-model="form.submitDate"
                    type="date"
                    placeholder="选择日期"
                    size="small"
                    style="width: 100%;"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker> -->
                  <div>{{ form.submitDate }}</div>
                </div>
              </div>
            </div>
        </div>
      </el-form>
    </el-card>

    <div style="text-align: center;">
        <el-button size="small"  class="btns"  type="primary" @click="save" v-if="showpopLongtitle !== '查看'">保存</el-button>
        <el-button size="small"  class="btns"  type="primary" @click="cancel">返回</el-button>
    </div>

    <Elupload
      v-if="isShowElupload"
      @handleEventElUpload="handleEventElUpload"
      @handleEventElUploadSubt="handleEventElUploadSubt"
      :Uploadtypes="Uploadtypes"
      :fileAllLists="fileAllLists"
    ></Elupload>



  </div>
</template>

<script>
import { getSubject, } from "@/api/firstClassApi";
import Elupload from "./Elupload.vue";
import axios from "axios";
import apiBaseUrl from "../../../../config/api";
import loadingUtils from "../../../utils/loading";
export default {
  components: {
    Elupload,
  },
  props: {

    studentData: {
      type: Object,
      default: () =>{
        return {}
      }
    },

    showpopLongtitle: {
      type: String,
      default: ''
    },

    dataRow: {
      type: Object,
      default: () =>{
        return {}
      }

    },
  },
  data() {
    return {

      form: {
        studentName: '',
        grade: '',
        subject: '',
        homework: '',
        classBehavior: '',
        summary: '',
        planContent: '',
        planContent1: '',
        planContent2: '',
        planInterpretation: '',
        studyAdvice: '',
        knowledgeGoal: '',
        examGoal: '',
        examSituation: '',
        campusBehavior: '',
        progress: '',
        approver: '',
        submitDate: ''
      },

      subjects: [],
      teachers: [],
      creators: [],
      fileList: [],
      uploadUrl: 'http://localhost:3000/upload',
      isShowElupload:false,

      fileAllLists:[],

      optionList2: [],

    };
  },

  mounted() {
    axios.get(`${apiBaseUrl}/orderCustomerAudit/findAuditList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
     this.optionList2 = res.data.data
    })


    this.getAllAxios()


    if(this.studentData && this.studentData.realname){
      this.form.student = this.studentData.realname ? this.studentData.realname : ''
      this.form.grade = this.studentData.gradeStr ? this.studentData.gradeStr : ''
    }


    console.log(this.dataRow , 'dataRow')

    if(this.dataRow && this.dataRow.id){
        this.form.id = this.dataRow.id ? this.dataRow.id : ''
        this.form.subject = this.dataRow.categoryId ? this.dataRow.categoryId : ''
        this.form.teacher = this.dataRow.teacherId ? this.dataRow.teacherId : ''
        this.form.homeworkCompletion = this.dataRow.taskCondition ? this.dataRow.taskCondition : ''
        this.form.classAbsorption = this.dataRow.classCondition ? this.dataRow.classCondition : ''
        this.form.campusPerformance = this.dataRow.campusExpression ? this.dataRow.campusExpression : ''
        this.form.recentExam = this.dataRow.examCondition ? this.dataRow.examCondition : ''
        this.form.spiritualAppearance = this.dataRow.spiritFace ? this.dataRow.spiritFace : ''

        if(this.dataRow.dataUploading && this.dataRow.dataUploading.length > 0){
           this.fileAllLists = this.dataRow.dataUploading 
        }else{
           this.fileAllLists = this.dataRow.dataUploading ? JSON.parse(this.dataRow.dataUploading) : []
        }

        this.form.categoryLeaveCondition = this.dataRow.categoryLeaveCondition ? this.dataRow.categoryLeaveCondition : ''
        this.form.categoryExpression = this.dataRow.categoryExpression ? this.dataRow.categoryExpression : ''
        this.form.studyProgressCondition = this.dataRow.studyProgressCondition ? this.dataRow.studyProgressCondition : ''





        this.form.studentName = this.dataRow.studentName ? this.dataRow.studentName : ''
        this.form.grade =  this.dataRow.grade ? this.dataRow.grade : ''
        this.form.subject = this.dataRow.categoryName ? this.dataRow.categoryName : ''
        this.form.homework = this.dataRow.taskCondition ? this.dataRow.taskCondition : ''
        this.form.classBehavior = this.dataRow.classCondition ? this.dataRow.classCondition : ''
        this.form.summary = this.dataRow.accomplishSummarize ? this.dataRow.accomplishSummarize : ''
        this.form.planContent = this.dataRow.contentOfCourses ? this.dataRow.contentOfCourses : ''
        this.form.planContent1 = this.dataRow.planUnscramble ? this.dataRow.planUnscramble : ''
        this.form.planContent2 = this.dataRow.categoryExpression ? this.dataRow.categoryExpression : ''
        this.form.knowledgeGoal = this.dataRow.knowledgeLevel ? this.dataRow.knowledgeLevel : ''
        this.form.examGoal = this.dataRow.examinationLevel ? this.dataRow.examinationLevel : ''
        this.form.examSituation = this.dataRow.examCondition ? this.dataRow.examCondition : ''
        this.form.campusBehavior = this.dataRow.campusExpression ? this.dataRow.campusExpression : ''
        this.form.progress = this.dataRow.studyProgressCondition ? this.dataRow.studyProgressCondition : ''
        this.form.approver = this.dataRow.auditName ? this.dataRow.auditName : ''
        this.form.submitDate = this.dataRow.commitDate ? this.dataRow.commitDate : ''


    }

  },

  methods: {

    downloadFile(name,url) {

    loadingUtils.startLoading()

    fetch(url).then(response => response.blob()).then(blob => {
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.download = name
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)

      setTimeout(() => {
        loadingUtils.endLoading()
        this.$message.success('文件下载成功~')
      }, 1000)

    })

    },

    getAllAxios() {

      axios.get(`${apiBaseUrl}/studentFeedback/getCategoryList/${this.studentData.id}`, { headers: { authorization: sessionStorage.getItem("tokenInfo"),  },}).then((res) => {
         this.subjects = res.data.data
      }).catch((error) => {
         this.$message({ type: 'error', message: error })
      })

      axios.get(`${apiBaseUrl}/studentFeedback/getTeacherList/${this.studentData.id}`, { headers: { authorization: sessionStorage.getItem("tokenInfo"),  },}).then((res) => {
         this.teachers = res.data.data
      }).catch((error) => {
         this.$message({ type: 'error', message: error })
      })


      // axios.get(`${apiBaseUrl}/schedule/teacherlist`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then((response) => {
      //       this.teachers = response.data.data
      // }).catch((error) => {
      //     this.$mesage.error(error)
      // })

      axios.get(`${apiBaseUrl}/questionnaire/queryCreator`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
            this.creators = res.data.data
        }).catch(error => {
          this.$message.error(error)
      })

      // getSubject().then((res) => { this.subjects = res.data; })

    },

    deletFile(type,list,index){
      this.$confirm('确定要删除该文件吗？', '提示', {  confirmButtonText: '确定',  cancelButtonText: '取消',  type: 'warning' }).then(() => {
        if (type === 1) {
            this.fileAllLists.splice(index, 1)
        }
        if (type === 2) {
            this.fileAllLists.splice(index, 1)
        }
         this.$message({   type: 'success',   message: '删除成功!' })
      }).catch(() => {
         this.$message({  type: 'info',  message: '已取消删除'  });
      })
    },

    handleUpload(type) {
      this.Uploadtypes = type
      // this.fileAllLists = []

      this.isShowElupload = true
    },
    handleEventElUploadSubt(flileList) {
      this.isShowElupload = false;
      if (flileList && flileList.length > 0) {
         this.fileAllLists = [...this.fileAllLists,...flileList]
      }

    },
    handleEventElUpload(flileList) {
      this.isShowElupload = false;
    },
    handleSuccess(response, file, fileList) {
      console.log('上传成功:', response, file, fileList);
    },
    save() {
      // 保存逻辑
      console.log('保存:', this.form);

      let data = {
        studentId: this.studentData.id,
        categoryId: this.form.subject,
        teacherId: this.form.teacher,
        campusExpression: this.form.campusPerformance,
        spiritFace: this.form.spiritualAppearance,
        taskCondition: this.form.homeworkCompletion,
        classCondition: this.form.classAbsorption,
        examCondition: this.form.recentExam,
        id: this.form.id ? this.form.id : '',
        dataUploading: this.fileAllLists ? JSON.stringify(this.fileAllLists) : '[]',
        categoryLeaveCondition: this.form.categoryLeaveCondition,
        categoryExpression: this.form.categoryExpression,
        studyProgressCondition: this.form.studyProgressCondition,


        // studentName: this.form.studentName,
        // grade: this.form.grade,
        // categoryName: this.form.subject,
        taskCondition: this.form.homework,
        classCondition: this.form.classBehavior,
        accomplishSummarize: this.form.summary,
        contentOfCourses: this.form.planContent,
        planUnscramble: this.form.planContent1,
        categoryExpression: this.form.planContent2,
        knowledgeLevel: this.form.knowledgeGoal,
        examinationLevel: this.form.examGoal,
        examCondition: this.form.examSituation,
        campusExpression: this.form.campusBehavior,
        studyProgressCondition: this.form.progress,
        // auditName: this.form.approver,
        // commitDate: this.form.submitDate,

      }

      let url = this.form.id ? 'studentFeedback/modify' : 'studentFeedback/add'

      axios.post(`${apiBaseUrl}/${url}`, data, { headers: { authorization: sessionStorage.getItem("tokenInfo"),},}).then((res) => {
          if (res.data.code === 200){
              this.$message({ type: 'success', message: '添加成功!' })
              this.$emit('handlecancel');
          }else{
            this.$message({ type: 'error', message: '添加失败!' })
          }
        }).catch((error) => {
          this.$message({ type: 'error', message: error })
     })

    },
    cancel() {
      // 返回逻辑
      console.log('取消');
      this.$emit('handlecancel');
      this.form = {
        studentName: '',
        grade: '',
        subject: '',
        homework: '',
        classBehavior: '',
        summary: '',
        planContent: '',
        planContent1: '',
        planContent2: '',
        planInterpretation: '',
        studyAdvice: '',
        knowledgeGoal: '',
        examGoal: '',
        examSituation: '',
        campusBehavior: '',
        progress: '',
        approver: '',
        submitDate: ''
      }
    }
  }
};
</script>

<style scoped>

.on-click{
  pointer-events: none;
}
.add-feedback-container {
  padding: 20px;
}
.add-feedback-card {
  margin-bottom: 20px;
}
.clearfix::after {
  content: '';
  display: block;
  clear: both;
}
.btns {
  background-color: #428bca;
  border-color: #428bca;
  color: #fff;
}


@keyframes flash {
  0% {
    opacity: 1;
    color: rgb(22, 145, 221);
  }
  14.2857% {
    opacity: 1;
    color: rgb(132, 29, 236);
  }
  28.5714% {
    opacity: 1;
    color: rgb(19, 205, 162);
  }
  42.8571% {
    opacity: 1;
    color: rgb(236, 28, 87);
  }
  57.1428% {
    opacity: 1;
    color: rgb(88, 200, 14);
  }
  71.4285% {
    opacity: 1;
    color: rgb(135, 172, 111);
  }
  85.7142% {
    opacity: 1;
    color: rgb(19, 205, 162);
  }
  100% {
    opacity: 1;
    color: rgb(236, 28, 87);
  }
}

.flashing-text {
  animation: flash 10s infinite alternate;
}

.two-lines {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5em;
}



.custom-table-container {
  font-size: 14px;
  padding: 20px;
}

.table-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid #000;
  padding: 10px 0px;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
}

.table-row {
  display: flex;
  min-height: 36px;
}

.cell {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.cell:last-child {
  border-right: none;
}

/* 左侧标签列 - 浅灰色 */
.label-cell {
  background-color: #e0e0e0;
  width: 180px;
  font-weight: bold;
  justify-content: center;
  text-align: center;
}

/* 第一行和最后一行的标签 - 更浅灰 */
.label-cell-light {
  background-color: #f0f0f0;
  width: 90px;
  font-weight: bold;
  justify-content: center;
  text-align: center;
}

/* 子标签（如“教学内容：”）*/
.sub-label {
  background-color: #f9f9f9;
  width: 100px;
  font-weight: normal;
  justify-content: flex-end;
  padding-right: 10px;
  color: #666;
}

/* 空单元格（用于 rowspan 视觉占位）*/
.empty {
  background-color: #e0e0e0;
  width: 180px;
  border-right: 1px solid #000;
}

/* 内容区域自动填充 */
.cell[colspan] {
  flex: 1;
}

</style>



// WEBPACK FOOTER //
// src/manager/components/subassembly/showpopLong.vue